import React from 'react';
import KeyIcon from '@mui/icons-material/Key';
import KeyOffIcon from '@mui/icons-material/KeyOff';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

interface DisplayKmsKeyStatusProps {
  availableKeys: string[] | null;
  missingKeys: string[] | null;
}

export default function DisplayKmsKeyStatus({
  availableKeys,
  missingKeys
}: DisplayKmsKeyStatusProps) {
  const { t } = useTranslation();

  if (
    (availableKeys === null || !availableKeys.length) &&
    (missingKeys === null || !missingKeys.length)
  )
    return null;

  const tooltipContent = (
    <Box>
      {availableKeys && availableKeys.length > 0 && (
        <Box>
          <Box component="span" sx={{ color: 'success.light' }}>
            {t('bconnectMaintenanceOrder.availableKeys') + ' : '}
          </Box>
          {availableKeys.join(', ')}
        </Box>
      )}
      {missingKeys && missingKeys.length > 0 && (
        <Box>
          <Box component="span" sx={{ color: 'error.light' }}>
            {t('bconnectMaintenanceOrder.missingKeys') + ' : '}
          </Box>
          {missingKeys.join(', ')}
        </Box>
      )}
    </Box>
  );

  return (
    <Tooltip title={tooltipContent} placement="right">
      <div>
        {availableKeys && availableKeys.length && (!missingKeys || !missingKeys.length) ? (
          <KeyIcon sx={{ color: 'success.main', fontSize: 'medium' }} />
        ) : (
          <KeyOffIcon sx={{ color: 'error.main', fontSize: 'medium' }} />
        )}
      </div>
    </Tooltip>
  );
}
